import axios from 'axios';
import authHeader from './api.auth.header';
import AuthService from './auth.service';
import router from '../../router';
import Vue from 'vue';

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASEURL,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Authorization",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE" ,
        "Content-Type": "application/json;charset=UTF-8",
    }
});

const authInterceptor = (config) => {
    config.headers['Authorization'] = authHeader();
    return config;
}

httpClient.interceptors.request.use(authInterceptor);

const errorInterceptor = error => {
    // check if it's a server error
    if (!error.response) {
      Vue.prototype.$msg.error("Erro no servidor");
      console.error('Network/Server error');
      return Promise.reject(error);
    }

    // all the other error responses
    switch(error.response.status) {
        case 400:
            if (error.response.data && error.response.data.message) {
                Vue.prototype.$msg.error(error.response.data.message);
                break;
            }
            error.response.data.errors.forEach(err => {
                Vue.prototype.$msg.error(err.campo + " - " + err.erro)
            });
            break;

        case 401:
            Vue.prototype.$msg.warning("Sessão expirada. Faça login novamente");
            AuthService.logout();
            router.push('/login');
            break;

        default:
            Vue.prototype.$msg.error("Erro no servidor");

    }
    return Promise.reject(error);
}

// Interceptor for responses
const responseInterceptor = response => {
    // switch(response.status) {
    //     case 200:
    //         break;
    //     // any other cases
    //     default:
    //         // default case
    // }
    return response;
}

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
